module.exports = __webpack_public_path__ + "static/media/peer_image6.39fd1b12.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/peer_image6.png
// module id = 2653
// module chunks = 0